export class ClientCornerHomePageInpressWorkerHelper {
  private constructor() {}

  static initializeInpressWorkers(): InpressWorkerDisplay[] {
    return [
      {
        department: 'Offerte',
        name: 'Tom Melis',
        initials: 'TM',
        phoneNumber: '03/870.70.29',
        displayEmailAddress: 'offerte@inpress.be',
        userEmailAddress: 'tom@inpress.be',
      },
      {
        department: 'Immo-afdeling',
        name: 'Cedric Heylen',
        initials: 'CH',
        phoneNumber: '03/825.40.16',
        displayEmailAddress: 'immo@inpress.be',
        userEmailAddress: 'cedric@inpress.be',
      },
      {
        department: 'Project-afdeling',
        name: 'Dieter Hannes',
        initials: 'DH',
        phoneNumber: '03/870.70.28',
        displayEmailAddress: 'project@inpress.be',
        userEmailAddress: 'dieter.hannes@inpress.be',
      },
    ];
  }
}

export interface InpressWorkerDisplay {
  department: string;
  name: string;
  initials: string;
  phoneNumber: string;
  displayEmailAddress: string;
  userEmailAddress: string;
  profilePictureUrl?: string;
}
